import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'
import { buttonVariants, type ButtonProps } from '@/components/ui/button'

type ButtonLinkProps = ComponentProps<'a'> &
  Pick<ButtonProps, 'variant' | 'size' | 'className'>

/**
 * Anchor styled as a Button. Prefer this over `Button render={<a />}` which is
 * easy to break when the render host has no children/props merge in SPA shells.
 */
export function ButtonLink({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: ButtonLinkProps) {
  return (
    <a
      className={cn(buttonVariants({ variant, size, className }))}
      data-slot="button"
      {...props}
    />
  )
}
